import { Box, Flex } from '@chakra-ui/react';
import { BiReportEmbed } from 'components/reports';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { useContext, useEffect, useState } from 'react';
import { getReportToken } from 'services/api/requests/biIntegration';
import { BiReportType } from 'services/api/variables/external/biExplorer';

import { helpSalesDashboard } from './variables/helpContent';

export default function SalesDashboard() {
	const { setters } = useContext(SidebarHelpContext);
	const { setDataSidebar } = setters;
	const [salesToken, setSalesToken] = useState<string>('');

	useEffect(() => {
		setDataSidebar(helpSalesDashboard);
	}, [helpSalesDashboard, setDataSidebar]);

	useEffect(() => {
		const fetchToken = async () => {
			const token = await getReportToken(BiReportType.SALES_REPORT);
			setSalesToken(token);
		};
		fetchToken();
	}, []);

	return (
		<Flex
			direction={'column'}
			pt={{ base: '130px', md: '80px', xl: '80px' }}
			px={{ base: 4, md: 6 }}
			gap={6}
			height='100vh'
		>
			<Box
				flex='1'
				minHeight='600px'
			>
				<BiReportEmbed
					reportToken={salesToken}
					containerHeight='calc(100vh - 200px)'
					autoLoad={true}
				/>
			</Box>
		</Flex>
	);
}
